import {
  BookingControllerApi,
  Configuration,
  CreateCaseOnlineMikroControllerApi,
  FileNetVtmControllerApi,
  FindBranchesControllerApi,
  FindCaseBySymbolsIdMikroControllerApi,
  FindValueListMikroControllerApi,
  GetCaseEventsMikroControllerApi,
  GetMessagesForCustomerMikroControllerApi,
  GetOfferDataMikroControllerApi,
  GetPreApprovedLoansMikroControllerApi,
  MessageReadMikroControllerApi,
  OnlineRectificationFinishedMikroControllerApi,
  SetAccountNoControllerApi,
  SetNextStepControllerApi,
  SetSignersControllerApi,
  SetSoftFactsControllerApi,
  UserProfileControllerApi,
} from "@smartx/mikro-vt-client-api"
import { FileNetVtmControllerApi as FileNetVtmControllerApiProxy } from "@smartx/mikro-vt-client-api-proxy"
import axios from "axios"

const VT_API_CLIENT_CONFIG = new Configuration({ basePath: "" })

export const bookingApi = new BookingControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const caseEventsApi = new GetCaseEventsMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const createCaseOnlineApi = new CreateCaseOnlineMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const fileNetApi = new FileNetVtmControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const fileNetProxyApi = new FileNetVtmControllerApiProxy(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const findBranchesApi = new FindBranchesControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const findCasesApi = new FindCaseBySymbolsIdMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const messageReadApi = new MessageReadMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const messagesApi = new GetMessagesForCustomerMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const offerDataApi = new GetOfferDataMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const offerPreApprovedLoansApi =
  new GetPreApprovedLoansMikroControllerApi(VT_API_CLIENT_CONFIG, "", axios)
export const offerSetAccountNoApi = new SetAccountNoControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const offerSetNextStepApi = new SetNextStepControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const offerSetSignersApi = new SetSignersControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const offerSetSoftFactsApi = new SetSoftFactsControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const rectificationApi =
  new OnlineRectificationFinishedMikroControllerApi(
    VT_API_CLIENT_CONFIG,
    "",
    axios,
  )
export const userProfileApi = new UserProfileControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
export const valueListApi = new FindValueListMikroControllerApi(
  VT_API_CLIENT_CONFIG,
  "",
  axios,
)
